import { render, staticRenderFns } from "./SignMoney.vue?vue&type=template&id=63561da8&scoped=true&"
import script from "./SignMoney.vue?vue&type=script&lang=js&"
export * from "./SignMoney.vue?vue&type=script&lang=js&"
import style0 from "./SignMoney.vue?vue&type=style&index=0&id=63561da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63561da8",
  null
  
)

export default component.exports